'use client';

import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Icon } from '@eliadmin/core/src/components/nt/ui/icon';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useOpenStaySignIn } from '@eliadmin/core/src/components/nt/shared/stay-sign-in-dialog';

/**
 * Figma „Login tip“ (168:14017): user icon, „Košík - prázdny prihlásenie“ and the „Prihlásiť sa“
 * link that opens the core sign-in dialog (as the header button). Guests only – a signed-in
 * customer's saved cart is already the one shown.
 */
export function SignInPrompt({ text, action }: { text: string; action: string }) {
  const me = useCustomerStore(state => state.me);
  const isInitialized = useCustomerStore(state => state.isInitialized);
  const locale = useLocaleStore(state => state.currentLocale);
  const openSignIn = useOpenStaySignIn();
  // Until the session is known the line keeps its place (no jump for the usual guest).
  if (me || !text) return null;

  const warmUp = () => void prefetchSocialAuthProviders(locale);

  return (
    <p className={cn('nt-body-m text-balance text-[#5D655D]', !isInitialized && 'invisible')}>
      <Icon name="user" size={16} className="mr-1.5 inline-block align-[-3px]" />
      {text}{' '}
      <button
        type="button"
        aria-haspopup="dialog"
        onClick={() => {
          warmUp();
          openSignIn();
        }}
        onFocus={warmUp}
        onMouseEnter={warmUp}
        className="nt-button-m whitespace-nowrap rounded text-[#0E6A20] underline underline-offset-2 transition-colors hover:text-[#0B5719] focus-visible:shadow-focus focus-visible:outline-none"
      >
        {action}
      </button>
    </p>
  );
}
